import React from 'react';
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

function TextLine(props) {
    props.elementProps.onKeyPress=(e)=>{if (e.key === 'Enter' || e.keyCode === 13) {e.target.blur()}}

    props.elementProps.onBlur = function (e) {
        props.setAnswer(e.target.value)
    }

    return (<Form.Control type="text" {...props.elementProps} />)
}
TextLine.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
};
export default TextLine;